// Generated by nuxt-echarts

import { use } from 'echarts/core'
import {
  CanvasRenderer,
} from 'echarts/renderers'
import {
  LineChart,
  BarChart,
  PieChart,
} from 'echarts/charts'
import {
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components'
import {

} from 'echarts/features'

use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,

])